import React from 'react';
import { styled as styled2 } from '@compiled/react';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/glyph/chevron-up';
import { colors } from '@atlaskit/theme';
import { N500 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

type Props = {
	isExpanded: boolean;
	label: string;
	onClick?: () => void;
	isDisabled?: boolean;
};

export const ExpandButton = ({
	label,
	isExpanded,
	onClick = () => null,
	isDisabled = false,
}: Props) => {
	// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
	const Chevron = isExpanded ? ChevronUpIcon : ChevronDownIcon;
	const chevronElement = (
		<Chevron
			size="large"
			primaryColor={
				isDisabled ? token('color.icon.disabled', '#BFDBF847') : token('color.icon', N500)
			}
			label={label}
		/>
	);

	return (
		<Container aria-expanded={isExpanded} onClick={onClick}>
			{chevronElement}
		</Container>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled2.div({
	padding: '0',
	margin: '0',
	width: token('space.400', '32px'),
	height: token('space.400', '32px'),
	border: 'none',
	backgroundColor: 'transparent',
	cursor: 'pointer',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	':focus': {
		boxShadow: 'none',
	},
	display: 'flex',
	flex: '0 0 auto',
	outline: 'none',
	transition: 'box-shadow 0.2s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	':focus.focus-visible': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		boxShadow: `inset 0 0 0 2px ${token('elevation.shadow.raised', colors.B100)}`,
	},
});
